import { MetricUnit } from "@/__generated__/graphql";
import { getUnit } from "@/utils/units";
import { RangeConfig, ThresholdConfig } from "@features/alertsConfigurationV2/schemas/alertConfigurationSchema";
import { useLingui } from "@lingui/react";
import { Box, Typography } from "@mui/material";

interface StateSummaryCardProps {
  unit: MetricUnit
  configuration:  RangeConfig | ThresholdConfig;
  index: number;
}

const getModalityLabel = (config: RangeConfig | ThresholdConfig) => {
  if (config.criteria === 'threshold') {
    return config.modality === 'above' ? 'Sobre' : 'Bajo';
  }
  return config.modality === 'in_range' ? 'Dentro de' : 'Fuera de';
}

export const StateSummaryRow = ({ configuration, unit, index }: StateSummaryCardProps) => {
  const { i18n } = useLingui();
  const suffix = getUnit(unit.toString().toUpperCase() as MetricUnit, i18n);
  const modalityLabel = getModalityLabel(configuration);


  return (
    <Box 
      key={index}
      sx={{ 
        width: 0.9,
        display: 'flex',
        flexDirection: 'row',
        gap: 2,
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          backgroundColor: '#2A3542',
          borderRadius: 2,
          p: 2,
          width: 0.25,
          textAlign: 'center',
        }}
      >
        <Typography variant="h6">{configuration.alertType}</Typography>
      </Box>
      <Box
        sx={{
          border: '1px solid grey',
          borderRadius: 2,
          width: 0.75,
          p: 2,
        }}
      >
        {configuration.criteria === 'threshold' && (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Typography variant='h6'>{modalityLabel} {configuration.threshold}{suffix!.short}</Typography>
          </Box>
        )}

        {configuration.criteria === 'range' && (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Typography variant='h6'>{modalityLabel} {configuration.minimum}{suffix!.short} y {configuration.maximum}{suffix!.short}</Typography>
          </Box>
        )}
      </Box>
    </Box>

  );
}
